import React from 'react'
import styles from './FranceService.module.css'
import { LogoVilleBasic, LogoCCASBasic } from '../../../svg/SvgComponents'
import logoFranceService from '../../../../assets/images/logo-france-service.png'

const FranceService = () => (
  <>
    <header className={styles.header}>
      <div className={styles.logo_img}>
        <img
          className={styles.img}
          src={logoFranceService}
          alt="Logo France Service"
        />
      </div>

      {/* Diviseur entre le logo France Service et les logos Ville et CCAS */}
      <div className={styles.divider}></div>

      <div className={styles.logo}>
        <LogoVilleBasic />
      </div>
      <div className={styles.logo}>
        <LogoCCASBasic />
      </div>
    </header>
  </>
)

export default FranceService
